import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import UserLogin from "@/pages/UserLogin";
import UserSignup from "@/pages/UserSignup";
import UserDashboard from "@/pages/UserDashboard";
import AdminUserDetail from "@/pages/AdminUserDetail";
import PDI from "@/pages/PDI";
import PDILanding from "@/pages/PDILanding";
import ReviewSubmit from "@/pages/ReviewSubmit";
import TierPage from "@/pages/TierPage";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to={role === "admin" ? "/admin" : "/login"} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin/dashboard" : "/dashboard"} replace />;
  }
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/drona" element={<TierPage />} />
            <Route path="/arjuna" element={<TierPage />} />
            <Route path="/bhishma" element={<TierPage />} />
            <Route path="/pdi" element={<PDILanding />} />
            <Route path="/review" element={<ReviewSubmit />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/signup" element={<UserSignup />} />
            <Route path="/dashboard" element={<Protected role="user"><UserDashboard /></Protected>} />
            <Route path="/pdi/:sessionId" element={<Protected role="user"><PDI /></Protected>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/admin/users/:id" element={<Protected role="admin"><AdminUserDetail /></Protected>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#181824",
            border: "1px solid rgba(139,92,246,0.35)",
            color: "#E8E8ED",
          },
        }}
      />
    </div>
  );
}
